/* @flow */

import type { JSON } from 'common/types';
import { failure } from 'common/json/extract';

export const boolean: JSON => boolean = (json: JSON) => {
  if (typeof json === 'boolean') {
    return json;
  }
  return failure(`Expecting boolean, got ${typeof json}`, () => Boolean(json));
};

export const string: JSON => string = (json: JSON) => {
  if (typeof json === 'string') {
    return json;
  }
  return failure(`Expecting string, got ${typeof json}`, () => String(json));
};

export const number: JSON => number = (json: JSON) => {
  if (typeof json === 'number') {
    return json;
  }
  return failure(`Expecting number, got ${typeof json}`, () => Number(json));
};

export const mixed: JSON => mixed = (json: JSON) => {
  return json;
};
